import { TeacherWorkloads } from 'widgets/teacher-workloads-table';
import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Нагрузка учителей',
    url: '',
  },
];

export const TeacherWorkloadsPage = () => {
  return (
    <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Нагрузка учителей">
      <TeacherWorkloads />
    </AppPage>
  );
};
